document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".image-banner-swiper").forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: 1,
      loop: false,
      effect: 'fade',
      pagination: {
        el: slider.querySelector(".image-banner-swiper-pagination"),
        clickable: true,
      },
       autoplay: {
        delay: 5000,
      },
      on: {
        init: function () {
          updateNavColors(this);
        },
        slideChange: function () {
          updateNavColors(this);
        },
      },

      navigation: {
        nextEl: slider.querySelector(".image-banner-swiper-next-btn"),
        prevEl: slider.querySelector(".image-banner-swiper-prev-btn"),
      },
    });
  });
});


function updateNavColors(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  
  const isMobile = window.innerWidth < 768;

  const navColor = isMobile 
    ? (activeSlide.dataset.navColorMobile || activeSlide.dataset.navColor)
    : activeSlide.dataset.navColor;

  const paginationColor = isMobile 
    ? (activeSlide.dataset.paginationColorMobile || activeSlide.dataset.paginationColor)
    : activeSlide.dataset.paginationColor;

  const section = activeSlide.closest('.image-banner-swiper-section');

  if (navColor) {
    section.style.setProperty('--swiper-nav-color', navColor);
  }
  if (paginationColor) {
    section.style.setProperty('--swiper-pagination-color', paginationColor);
  }
}

window.addEventListener("resize", () => {
  document.querySelectorAll(".image-banner-swiper").forEach((slider) => {
    const swiperInstance = slider.swiper;
    if (swiperInstance) {
      updateNavColors(swiperInstance);
    }
  });
});